/**
 * @generated SignedSource<<bb8bcb56e40a10fffd94140296b1e948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConfigureActivityManagementRoundSessionQuery$variables = {
  duration?: number | null | undefined;
  playerCount?: number | null | undefined;
  shareId: string;
};
export type ConfigureActivityManagementRoundSessionQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly firstName?: string | null | undefined;
        readonly id?: string;
        readonly lastName?: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly sharedBooking: {
    readonly ownerClient: {
      readonly id?: string;
    } | null | undefined;
    readonly rounds: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly player: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"ConfigureActivityManagementRoundPlayerRate_Booking" | "useInitializeRound_Booking">;
  } | null | undefined;
};
export type ConfigureActivityManagementRoundSessionQuery = {
  response: ConfigureActivityManagementRoundSessionQuery$data;
  variables: ConfigureActivityManagementRoundSessionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "duration"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "playerCount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  }
],
v5 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Member",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": (v4/*: any*/),
  "type": "Customer",
  "abstractKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "shareId",
    "variableName": "shareId"
  }
],
v8 = [
  (v3/*: any*/)
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Member",
  "abstractKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Customer",
  "abstractKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v13 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "rate",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v3/*: any*/),
    (v14/*: any*/)
  ],
  "storageKey": null
},
v16 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "holeCount",
    "storageKey": null
  }
],
v17 = {
  "alias": "nineHolePrice",
  "args": [
    {
      "kind": "Literal",
      "name": "holeCount",
      "value": "NINE"
    }
  ],
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
},
v18 = {
  "alias": "eighteenHolePrice",
  "args": [
    {
      "kind": "Literal",
      "name": "holeCount",
      "value": "EIGHTEEN"
    }
  ],
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ConfigureActivityManagementRoundSessionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharedBooking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ownerClient",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConfigureActivityManagementRoundPlayerRate_Booking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useInitializeRound_Booking"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoundConnection",
            "kind": "LinkedField",
            "name": "rounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ConfigureActivityManagementRoundSessionQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharedBooking",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isBooking"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ownerClient",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "startSlot",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "durationPlayerRates",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "highestPrecedentOnly",
                        "value": false
                      },
                      (v13/*: any*/)
                    ],
                    "concreteType": "SlotRate",
                    "kind": "LinkedField",
                    "name": "playerRates",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "duration",
                            "variableName": "duration"
                          },
                          {
                            "kind": "Variable",
                            "name": "playerCount",
                            "variableName": "playerCount"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "totalDurationPrice",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "playerRates(highestPrecedentOnly:false,type:\"CUSTOMER\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agenda",
                    "kind": "LinkedField",
                    "name": "agenda",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "memberVisible",
                        "value": true
                      }
                    ],
                    "concreteType": "CourseLayoutConnection",
                    "kind": "LinkedField",
                    "name": "permittedCourseLayouts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseLayoutEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseLayout",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "permittedCourseLayouts(memberVisible:true)"
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              },
              {
                "alias": null,
                "args": [
                  (v13/*: any*/)
                ],
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRates",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": "playerRates(type:\"CUSTOMER\")"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoundConnection",
            "kind": "LinkedField",
            "name": "rounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TransportationType",
                        "kind": "LinkedField",
                        "name": "transportationType",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseLayout",
                        "kind": "LinkedField",
                        "name": "courseLayout",
                        "plural": false,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoundRate",
                        "kind": "LinkedField",
                        "name": "roundRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appliesToMembershipType",
                            "storageKey": null
                          },
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v3/*: any*/),
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "visibility",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1958a585b031a1ff4b3b185856c34db9",
    "id": null,
    "metadata": {},
    "name": "ConfigureActivityManagementRoundSessionQuery",
    "operationKind": "query",
    "text": "query ConfigureActivityManagementRoundSessionQuery(\n  $shareId: String!\n  $duration: Int\n  $playerCount: Int\n) {\n  session {\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        ... on Member {\n          id\n          firstName\n          lastName\n        }\n        ... on Customer {\n          id\n          firstName\n          lastName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  sharedBooking(shareId: $shareId) {\n    __typename\n    __isBooking: __typename\n    ownerClient {\n      __typename\n      ... on Member {\n        id\n      }\n      ... on Customer {\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ...ConfigureActivityManagementRoundPlayerRate_Booking\n    ...useInitializeRound_Booking\n    rounds {\n      edges {\n        node {\n          __typename\n          id\n          player {\n            __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ConfigureActivityManagementRoundPlayerRate_Booking on Booking {\n  __isBooking: __typename\n  ...useGetActivityManagementPlayerRateOptions_Booking\n}\n\nfragment useGetActivityManagementPlayerRateOptions_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n    ... on TimeSlot {\n      durationPlayerRates: playerRates(highestPrecedentOnly: false, type: CUSTOMER) {\n        rate {\n          __typename\n          id\n          name\n        }\n        totalDurationPrice(duration: $duration, playerCount: $playerCount)\n      }\n    }\n  }\n}\n\nfragment useInitializeRound_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n    ... on TimeSlot {\n      agenda {\n        facility {\n          type\n          id\n        }\n        id\n      }\n      permittedCourseLayouts(memberVisible: true) {\n        edges {\n          node {\n            id\n            holeCount\n          }\n        }\n      }\n    }\n    playerRates(type: CUSTOMER) {\n      rate {\n        __typename\n        id\n        name\n      }\n      nineHolePrice: totalGolfPrice(holeCount: NINE)\n      eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n    }\n  }\n  rounds {\n    edges {\n      node {\n        id\n        __typename\n        transportationType {\n          id\n        }\n        courseLayout {\n          id\n          holeCount\n        }\n        roundRate {\n          appliesToMembershipType\n          nineHolePrice: totalGolfPrice(holeCount: NINE)\n          eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n          rate {\n            __typename\n            id\n            name\n            visibility\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f550dbac9b15180932bcc1a5f8c04943";

export default node;
